import { AuthServiceCustom } from './../../../auth/authServiceCustom';
// Angular
import { Injectable } from '@angular/core';
import * as objectPath from 'object-path';
// RxJS
import { Subject } from 'rxjs';

@Injectable()
export class MenuConfigService {
  // Public properties
  onConfigUpdated$: Subject<any>;
  // Private properties
  private menuConfig: any;

  /**
   * Service Constructor
   */
  constructor(private authService: AuthServiceCustom) {
    // register on config changed event and set default config
    this.onConfigUpdated$ = new Subject();
  }

  /**
   * Returns the menuConfig
   */
  getMenus() {
    return this.menuPermission(this.menuConfig);
  }

  /**
   * Load config
   *
   * @param config: any
   */
  loadConfigs(config: any) {
    this.menuConfig = config;
    this.onConfigUpdated$.next(this.menuConfig);
  }

  private menuPermission(menuConfig: any) {
    let menuItems = objectPath.get(menuConfig, 'aside.items');
    //const rolesUser = JSON.parse(sessionStorage.getItem("userNotPermission"));

    const users = [
      'elio.alves',
      'romeu.sebastiao',
      'anderson.vieira',
      'marcos.c.neto',
      'douglas.mcosta'
    ]

    for (let item of menuItems) {

      if (item.title && item.title === 'Ferramentas' && (this.authService.userName && !users.includes(this.authService.userName.toLowerCase()))) {
        item.notHasPermission = true;
      }

      if (item.section && item.section === 'Administrativo' && (this.authService.userName && !users.includes(this.authService.userName.toLowerCase()))) {
        item.notHasPermission = true;
      }

      // else {

      //   if (item.submenu) {

      //     let submenuValue = item.submenu;

      //     for (let subItem of submenuValue) {

      //       if (rolesUser.includes(subItem.roles)) {

      //         subItem.notHasPermission = true;
      //       }
      //     }
      //   }
      // }
    }

    menuConfig.aside.items = menuItems;
    return menuConfig;
  }
}
